<template>
	<b-modal ref="event-report-modal" title="Event Report" v-model="show" v-if="rec">

		<b-row>
			<b-col><label class="font-weight-bold">Date:</label></b-col>
			<b-col cols="8">{{ $datetime.date(rec.time) }}</b-col>
		</b-row>
		<b-row>
			<b-col><label class="font-weight-bold">Time:</label></b-col>
			<b-col cols="8">{{ $datetime.time(rec.time) }}</b-col>
		</b-row>
		<b-row>
			<b-col><label class="font-weight-bold">Zone:</label></b-col>
			<b-col cols="8">{{ $zone.get(rec.zone_id).name }}</b-col>
		</b-row>
		<b-row>
			<b-col><label class="font-weight-bold">Asset Name:</label></b-col>
			<b-col cols="8">{{ rec.worker.first_name }} {{ rec.worker.last_name }}</b-col>
		</b-row>
		<b-row>
			<b-col><label class="font-weight-bold">Asset Trade:</label></b-col>
			<b-col cols="8">
				{{worker_types[workers[rec.worker.id].type].label}}<br>
				{{ workers[rec.worker.id].job }}
			</b-col>
		</b-row>

		<b-row v-if="rec.resolution.key">
			<b-col><label class="font-weight-bold">Resolution type:</label></b-col>
			<b-col cols="8">
				{{rec.resolution.type_label}}
			</b-col>
		</b-row>

		<b-row v-if="rec.exit.key">
			<b-col><label class="font-weight-bold">Exit date/time:</label></b-col>
			<b-col cols="8">
				{{$datetime.date(rec.exit.time)}} {{$datetime.time(rec.exit.time)}}
			</b-col>
		</b-row>

		<div slot="modal-footer">
			<button type="button" class="btn btn-secondary" @click="show=false">Close</button>
		</div>

	</b-modal>
</template>

<script>

	export default {
		name: 'EventReport',
		data() {
			return {
				show: false,
				rec: null,
				key: null,
			}
		},
		watch: {
			alert: {
				handler() {
					this.rec = this.alert[this.key];
				}
			},
			deep: true
		},
		computed: {
			alert() { return this.$store.state.alert },
			end_time() { return this.$config.end_time},
			workers() { return this.$store.state.workers },
			worker_types() { return this.$config.worker_types }
		},
		mounted() {
			this.init();

		},
		methods: {
			init() {

			},
			showModal(key) {
				this.key = key;
				this.show = true;
				this.rec = this.alert[key];
			}

		}
	}
</script>
